import { ReactComponent as IconSvg } from './icon_tick.svg';
import Icon, { IconProps } from './icon';

const IconTick = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconTick;
